export default __webpack_public_path__ + "static/media/firma_white.511ebd7c.svg";